import { fields, createSchema, validate as _validate } from '..';
const { email, name, optionalArrayOfString, organisationOther } = fields;

const user = createSchema({
  email,
  name,
  localAuthorities: optionalArrayOfString,
  organisationOther
});

const validate = data => _validate(user, data);

export default validate;
